export const tableStyle = theme => ({
    tableContainer: {
        height: '100%',
        display: 'flex',
        '& > div': {
            width: '100%',
        },
        '& tr[level="1"]': {
            paddingLeft: 100,
        },
    },
    connectorIcon: {
        marginRight: theme.spacing(),

        '&:last-child': {
            marginRight: 0,
        },
    },
});
